import { render, staticRenderFns } from "./LaporanRp1MenuPage.vue?vue&type=template&id=ce10b51c&scoped=true&"
import script from "./LaporanRp1MenuPage.vue?vue&type=script&lang=ts&"
export * from "./LaporanRp1MenuPage.vue?vue&type=script&lang=ts&"
import style0 from "./LaporanRp1MenuPage.vue?vue&type=style&index=0&id=ce10b51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10b51c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VContainer,VIcon,VRow})
